/* eslint-disable complexity */
/* eslint-disable camelcase */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-statements */
/* eslint-disable max-lines-per-function */
// Libraries
import { FormElems, Alert } from '../';
import {
    showLoader,
    hideLoader,
} from '../../redux/common/loader/loader.actions';
import {
    updateRoleRequest,
    updateRoleReset,
} from '../../containers/RoleManagement/redux/roleManagement.actions';
import {
    getRoleStatusOptions,
    capitaliseString,
} from '../../utils/helperMethods';
import validate from './validator';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

// Components

// Actions

// Helper Methods

// Validator

// Styles
import './RoleViewEditForm.scss';

const RoleViewEditForm = props => {
    const {
        closePopup,
        handleSubmit,
        actionType,
        actions,
        data,
        handleOpenActionPopup,
        roleManagementData,
        formData,
        fetchData,
        resetPage,
        isPendingMode,
    } = props;

    const { updateRole, allResourcePermissionDetails } = roleManagementData;

    const [accessManagementOptions, setAccessManagementOptions] = useState([]);
    const [mobOptions, setMobOptions] = useState([]);
    const [payLinkOptions, setPayLinkOptions] = useState([]);
    const [reportOptions, setReportOptions] = useState([]);
    const [refundOptions, setRefundOptions] = useState([]);
    const [manageBinOptions, setManageBinOptions] = useState([]);
    const [manageAccountOptions, setManageAccountOptions] = useState([]);
    const [myAccountOptions, setMyAccountOptions] = useState([]);
    const [dashboardOptions, setDashboardOptions] = useState([]);
    const [auditTrailOptions, setAuditTrailOptions] = useState([]);
    const [settlementOptions, setSettlementOptions] = useState([]);
    const [mandateOptions, setMandateOptions] = useState([]);
    const [chargebackOptions, setChargebackOptions] = useState([]);
    const [mobEditOptions, setMobEditOptions] = useState([]);
    const [merchantAdjustmentOptions, setMerchantAdjustmentOptions] = useState(
        []
    );

    useEffect(() => {
        if (updateRole.isSuccess) {
            closePopup();
            fetchData({ pageIndex: 1, pageSize: 10 });
            resetPage();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchData, updateRole.isSuccess]);

    useEffect(() => {
        // reset data
        return () => {
            actions.updateRoleReset();
        };
    }, [actions]);

    useEffect(() => {
        const resourcePermissionDetails = [...allResourcePermissionDetails];

        const accessManagementResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'access_management'
            ),
        };

        const mobResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'merchant_onboarding'
            ),
        };
        const mobEditResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'edit_merchant_onboarding'
            ),
        };

        const paymentLinkSource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'payment_links'
            ),
        };

        const reportResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'reports'
            ),
        };

        const refundResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'refunds'
            ),
        };

        const manageBinResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'manage_bin'
            ),
        };

        const manageAccountResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'manage_account'
            ),
        };

        const myAccountResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'my_account'
            ),
        };

        const dashboardResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'dashboard'
            ),
        };

        const auditTrailResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'audit_trail'
            ),
        };

        const settlementResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'view_settlement'
            ),
        };

        const merchantAdjustmentResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'view_merchant_adjustment'
            ),
        };

        const mandateResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'mandates'
            ),
        };

        const chargebackResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'chargeback'
            ),
        };

        let accessManagementOptions =
            accessManagementResource.permissionDetail &&
            accessManagementResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let mobOptions =
            mobResource.permissionDetail &&
            mobResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

            let mobEditOptions =
            mobEditResource.permissionDetail &&
            mobEditResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));
 
        let payLinkOptions =
            paymentLinkSource.permissionDetail &&
            paymentLinkSource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let reportOptions =
            reportResource.permissionDetail &&
            reportResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let refundOptions =
            refundResource.permissionDetail &&
            refundResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let manageBinOptions =
            manageBinResource.permissionDetail &&
            manageBinResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let manageAccountOptions =
            manageAccountResource.permissionDetail &&
            manageAccountResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let myAccountOptions =
            myAccountResource.permissionDetail &&
            myAccountResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let dashboardOptions =
            dashboardResource.permissionDetail &&
            dashboardResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let auditTrailOptions =
            auditTrailResource.permissionDetail &&
            auditTrailResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));
        let settlementOptions =
            settlementResource.permissionDetail &&
            settlementResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let merchantAdjustmentOptions =
            merchantAdjustmentResource.permissionDetail &&
            merchantAdjustmentResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let mandateOptions =
            mandateResource.permissionDetail &&
            mandateResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let chargebackOptions =
            chargebackResource.permissionDetail &&
            chargebackResource.permissionDetail.map(perm => ({
                label: capitaliseString(
                    perm.permissionName.split('_').join(' ')
                ),
                value: perm.permissionId,
            }));

        let userAccessManagementOptions = data.resourceDetail.find(
            res => res.resourceName === 'access_management'
        );

        if (userAccessManagementOptions) {
            userAccessManagementOptions = userAccessManagementOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userAccessManagementOptions = [];
        }

        let userMobOptions = data.resourceDetail.find(
            res => res.resourceName === 'merchant_onboarding'
        );

        if (userMobOptions) {
            userMobOptions = userMobOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userMobOptions = [];
        }

        let userMobEditOptions = data.resourceDetail.find(
            res => res.resourceName === 'edit_merchant_onboarding'
        );

        if (userMobEditOptions) {
            userMobEditOptions = userMobEditOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userMobEditOptions = [];
        }


        let userPayLinkOptions = data.resourceDetail.find(
            res => res.resourceName === 'payment_links'
        );

        if (userPayLinkOptions) {
            userPayLinkOptions = userPayLinkOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userPayLinkOptions = [];
        }

        let userReportOptions = data.resourceDetail.find(
            res => res.resourceName === 'reports'
        );

        if (userReportOptions) {
            userReportOptions = userReportOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userReportOptions = [];
        }

        let userRefundOptions = data.resourceDetail.find(
            res => res.resourceName === 'refunds'
        );

        if (userRefundOptions) {
            userRefundOptions = userRefundOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userRefundOptions = [];
        }

        let userManageBinOptions = data.resourceDetail.find(
            res => res.resourceName === 'manage_bin'
        );

        if (userManageBinOptions) {
            userManageBinOptions = userManageBinOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userManageBinOptions = [];
        }

        let userManageAccountOptions = data.resourceDetail.find(
            res => res.resourceName === 'manage_account'
        );

        if (userManageAccountOptions) {
            userManageAccountOptions = userManageAccountOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userManageAccountOptions = [];
        }

        let userMyAccountOptions = data.resourceDetail.find(
            res => res.resourceName === 'my_account'
        );

        if (userMyAccountOptions) {
            userMyAccountOptions = userMyAccountOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userMyAccountOptions = [];
        }

        let userDashboardOptions = data.resourceDetail.find(
            res => res.resourceName === 'dashboard'
        );

        if (userDashboardOptions) {
            userDashboardOptions = userDashboardOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            userDashboardOptions = [];
        }

        let auditTrailFormatOptions = data.resourceDetail.find(
            res => res.resourceName === 'audit_trail'
        );

        if (auditTrailFormatOptions) {
            auditTrailFormatOptions = auditTrailFormatOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            auditTrailFormatOptions = [];
        }
        let settlementFormatOptions = data.resourceDetail.find(
            res => res.resourceName === 'view_settlement'
        );

        if (settlementFormatOptions) {
            settlementFormatOptions = settlementFormatOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            settlementFormatOptions = [];
        }

        let merchantAdjustmentFormatOptions = data.resourceDetail.find(
            res => res.resourceName === 'view_merchant_adjustment'
        );

        if (merchantAdjustmentFormatOptions) {
            merchantAdjustmentFormatOptions = merchantAdjustmentFormatOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            merchantAdjustmentFormatOptions = [];
        }

        let mandateFormatOptions = data.resourceDetail.find(
            res => res.resourceName === 'mandates'
        );

        if (mandateFormatOptions) {
            mandateFormatOptions = mandateFormatOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            mandateFormatOptions = [];
        }

        let chargebackFormatOptions = data.resourceDetail.find(
            res => res.resourceName === 'chargeback'
        );

        if (chargebackFormatOptions) {
            chargebackFormatOptions = chargebackFormatOptions.permissionDetail.map(
                perm => perm.permissionId
            );
        } else {
            chargebackFormatOptions = [];
        }

        accessManagementOptions =
            accessManagementOptions &&
            accessManagementOptions.map(opt => {
                if (userAccessManagementOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        mobOptions =
            mobOptions &&
            mobOptions.map(opt => {
                if (userAccessManagementOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        payLinkOptions =
            payLinkOptions &&
            payLinkOptions.map(opt => {
                if (userPayLinkOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        reportOptions =
            reportOptions &&
            reportOptions.map(opt => {
                if (userReportOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        refundOptions =
            refundOptions &&
            refundOptions.map(opt => {
                if (userRefundOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        manageBinOptions =
            manageBinOptions &&
            manageBinOptions.map(opt => {
                if (userManageBinOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        manageAccountOptions =
            manageAccountOptions &&
            manageAccountOptions.map(opt => {
                if (userManageAccountOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        myAccountOptions =
            myAccountOptions &&
            myAccountOptions.map(opt => {
                if (userMyAccountOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        dashboardOptions =
            dashboardOptions &&
            dashboardOptions.map(opt => {
                if (userDashboardOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        auditTrailOptions =
            auditTrailOptions &&
            auditTrailOptions.map(opt => {
                if (auditTrailFormatOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });
        settlementOptions =
            settlementOptions &&
            settlementOptions.map(opt => {
                if (settlementFormatOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });
        merchantAdjustmentOptions =
            merchantAdjustmentOptions &&
            merchantAdjustmentOptions.map(opt => {
                if (merchantAdjustmentFormatOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        mandateOptions =
            mandateOptions &&
            mandateOptions.map(opt => {
                if (mandateFormatOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        chargebackOptions =
            chargebackOptions &&
            chargebackOptions.map(opt => {
                if (chargebackFormatOptions.includes(opt.value)) {
                    return {
                        ...opt,
                        checked: true,
                    };
                }
                return opt;
            });

        setAccessManagementOptions(accessManagementOptions);
        setMobOptions(mobOptions);
        setPayLinkOptions(payLinkOptions);
        setReportOptions(reportOptions);
        setRefundOptions(refundOptions);
        setManageBinOptions(manageBinOptions);
        setManageAccountOptions(manageAccountOptions);
        setMyAccountOptions(myAccountOptions);
        setDashboardOptions(dashboardOptions);
        setAuditTrailOptions(auditTrailOptions);
        setSettlementOptions(settlementOptions);
        setMerchantAdjustmentOptions(merchantAdjustmentOptions);
        setMandateOptions(mandateOptions);
        setChargebackOptions(chargebackOptions);
        setMobEditOptions(mobEditOptions);
    }, [allResourcePermissionDetails, data.resourceDetail]);

    const onEdit = event => {
        event.preventDefault();
        handleOpenActionPopup('edit');
    };

    const onCancel = event => {
        event.preventDefault();
        closePopup();
    };

    function handleFormSubmit(formData) {
        const resourcePermissionDetails = [...allResourcePermissionDetails];
        const values = { ...formData };
        const reqPayload = {};

        // reqPayload.roleName = values.roleName;
        reqPayload.roleStatus = values.roleStatus;
        reqPayload.comment = values.remarks;
        reqPayload.roleId = data.roleId;
        const resourceDetail = [];
        const accessManagementResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'access_management'
            ),
        };
        const mobResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'merchant_onboarding'
            ),
        };
        const mobEditResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'edit_merchant_onboarding'
            ),
        };

        const payLinkResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'payment_links'
            ),
        };

        const reportResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'reports'
            ),
        };
        const refundResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'refunds'
            ),
        };
        const manageBinResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'manage_bin'
            ),
        };
        const manageAccountResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'manage_account'
            ),
        };
        const myAccountResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'my_account'
            ),
        };
        const dashboardResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'dashboard'
            ),
        };

        const auditTrailResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'audit_trail'
            ),
        };
        const settlementResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'view_settlement'
            ),
        };
        const merchantAdjustmentResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'view_merchant_adjustment'
            ),
        };

        const mandateResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'mandates'
            ),
        };

        const chargebackResource = {
            ...resourcePermissionDetails.find(
                res => res.resourceName === 'chargeback'
            ),
        };

        if (!values.access_management) {
            const amValues = values.resourceDetail.find(
                res => res.resourceName === 'access_management'
            );

            if (amValues) {
                values.access_management = amValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.access_management = [];
            }
        }
        if (!values.merchant_onboarding) {
            const mobValues = values.resourceDetail.find(
                res => res.resourceName === 'merchant_onboarding'
            );

            if (mobValues) {
                values.merchant_onboarding = mobValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.merchant_onboarding = [];
            }
        }
        if (!values.edit_merchant_onboarding) {
            const mobEditValues = values.resourceDetail.find(
                res => res.resourceName === 'edit_merchant_onboarding'
            );

            if (mobEditValues) {
                values.edit_merchant_onboarding = mobEditValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.edit_merchant_onboarding = [];
            }
        }
        if (!values.payLink) {
            const payLinkValues = values.resourceDetail.find(
                res => res.resourceName === 'payment_links'
            );

            if (payLinkValues) {
                values.payLink = payLinkValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.payLink = [];
            }
        }

        if (!values.reports) {
            const reportValues = values.resourceDetail.find(
                res => res.resourceName === 'reports'
            );

            if (reportValues) {
                values.reports = reportValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.reports = [];
            }
        }
        if (!values.refunds) {
            const refundValues = values.resourceDetail.find(
                res => res.resourceName === 'refunds'
            );

            if (refundValues) {
                values.refunds = refundValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.refunds = [];
            }
        }
        if (!values.manage_bin) {
            const manageBinValues = values.resourceDetail.find(
                res => res.resourceName === 'manage_bin'
            );

            if (manageBinValues) {
                values.manage_bin = manageBinValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.manage_bin = [];
            }
        }
        if (!values.manage_account) {
            const manageAccountValues = values.resourceDetail.find(
                res => res.resourceName === 'manage_account'
            );

            if (manageAccountValues) {
                values.manage_account = manageAccountValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.manage_account = [];
            }
        }
        if (!values.my_account) {
            const myAccountValues = values.resourceDetail.find(
                res => res.resourceName === 'my_account'
            );

            if (myAccountValues) {
                values.my_account = myAccountValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.my_account = [];
            }
        }
        if (!values.dashboard) {
            const dashboardValues = values.resourceDetail.find(
                res => res.resourceName === 'dashboard'
            );

            if (dashboardValues) {
                values.dashboard = dashboardValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.dashboard = [];
            }
        }

        if (!values.audit_trail) {
            const auditTrailValues = values.resourceDetail.find(
                res => res.resourceName === 'audit_trail'
            );

            if (auditTrailValues) {
                values.audit_trail = auditTrailValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.audit_trail = [];
            }
        }

        if (!values.view_settlement) {
            const settlementValues = values.resourceDetail.find(
                res => res.resourceName === 'view_settlement'
            );

            if (settlementValues) {
                values.view_settlement = settlementValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.view_settlement = [];
            }
        }

        if (!values.view_merchant_adjustment) {
            const merchantAdjustmentValues = values.resourceDetail.find(
                res => res.resourceName === 'view_merchant_adjustment'
            );

            if (merchantAdjustmentValues) {
                values.view_merchant_adjustment = merchantAdjustmentValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.view_merchant_adjustment = [];
            }
        }

        if (!values.mandates) {
            const mandateValues = values.resourceDetail.find(
                res => res.resourceName === 'mandates'
            );
            if (mandateValues) {
                values.mandates = mandateValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.mandates = [];
            }
        }

        if (!values.chargeback) {
            const chargebackValues = values.resourceDetail.find(
                res => res.resourceName === 'chargeback'
            );
            if (chargebackValues) {
                values.chargeback = chargebackValues.permissionDetail.map(
                    val => val.permissionId
                );
            } else {
                values.chargeback = [];
            }
        }

        const selectedAccessManagementResourcePerm = accessManagementResource.permissionDetail.filter(
            perm => values.access_management.includes(perm.permissionId)
        );

        const selectedMobResourcePerm = mobResource.permissionDetail.filter(
            perm => values.merchant_onboarding.includes(perm.permissionId)
        );

        const selectedMobEditResourcePerm = mobEditResource.permissionDetail.filter(
            perm => values.edit_merchant_onboarding.includes(perm.permissionId)
        );

        const selectedPayLinkResourcePerm = payLinkResource.permissionDetail.filter(
            perm => values.payLink.includes(perm.permissionId)
        );

        const selectedReportResourcePerm = reportResource.permissionDetail.filter(
            perm => values.reports.includes(perm.permissionId)
        );

        const selectedRefundResourcePerm = refundResource.permissionDetail.filter(
            perm => values.refunds.includes(perm.permissionId)
        );

        const selectedManageBinResourcePerm = manageBinResource.permissionDetail.filter(
            perm => values.manage_bin.includes(perm.permissionId)
        );

        const selectedManageAccountResourcePerm = manageAccountResource.permissionDetail.filter(
            perm => values.manage_account.includes(perm.permissionId)
        );

        const selectedMyAccountResourcePerm = myAccountResource.permissionDetail.filter(
            perm => values.my_account.includes(perm.permissionId)
        );

        const selectedDashboardResourcePerm = dashboardResource.permissionDetail.filter(
            perm => values.dashboard.includes(perm.permissionId)
        );

        const selectedAuditTrailResourcePerm = auditTrailResource.permissionDetail.filter(
            perm => values.audit_trail.includes(perm.permissionId)
        );

        const selectedSettlementTrailResourcePerm = settlementResource.permissionDetail.filter(
            perm => values.view_settlement.includes(perm.permissionId)
        );
        const selectedMerchantAdjustmentTrailResourcePerm = merchantAdjustmentResource.permissionDetail.filter(
            perm => values.view_merchant_adjustment.includes(perm.permissionId)
        );

        const selectedMandateResourcePerm = mandateResource.permissionDetail.filter(
            perm => values.mandates.includes(perm.permissionId)
        );

        const selectedChargebackResourcePerm = chargebackResource.permissionDetail.filter(
            perm => values.chargeback.includes(perm.permissionId)
        );

        accessManagementResource.permissionDetail = selectedAccessManagementResourcePerm;
        mobResource.permissionDetail = selectedMobResourcePerm;
        mobEditResource.permissionDetail = selectedMobEditResourcePerm;
        payLinkResource.permissionDetail = selectedPayLinkResourcePerm;
        reportResource.permissionDetail = selectedReportResourcePerm;
        refundResource.permissionDetail = selectedRefundResourcePerm;
        manageBinResource.permissionDetail = selectedManageBinResourcePerm;
        manageAccountResource.permissionDetail = selectedManageAccountResourcePerm;
        myAccountResource.permissionDetail = selectedMyAccountResourcePerm;
        dashboardResource.permissionDetail = selectedDashboardResourcePerm;
        auditTrailResource.permissionDetail = selectedAuditTrailResourcePerm;
        selectedSettlementTrailResourcePerm.permissionDetail = selectedSettlementTrailResourcePerm;
        selectedMerchantAdjustmentTrailResourcePerm.permissionDetail = selectedMerchantAdjustmentTrailResourcePerm;
        selectedMandateResourcePerm.permissionDetail = selectedMandateResourcePerm;
        selectedChargebackResourcePerm.permissionDetail = selectedChargebackResourcePerm;

        if (selectedAccessManagementResourcePerm.length > 0) {
            resourceDetail.push(accessManagementResource);
        }
        if (selectedMobResourcePerm.length > 0) {
            resourceDetail.push(mobResource);
        }
        if (selectedMobEditResourcePerm.length > 0) {
            resourceDetail.push(mobResource);
        }

        if (selectedPayLinkResourcePerm.length > 0) {
            resourceDetail.push(payLinkResource);
        }

        if (selectedReportResourcePerm.length > 0) {
            resourceDetail.push(reportResource);
        }
        if (selectedRefundResourcePerm.length > 0) {
            resourceDetail.push(refundResource);
        }
        if (selectedManageBinResourcePerm.length > 0) {
            resourceDetail.push(manageBinResource);
        }
        if (selectedManageAccountResourcePerm.length > 0) {
            resourceDetail.push(manageAccountResource);
        }
        if (selectedMyAccountResourcePerm.length > 0) {
            resourceDetail.push(myAccountResource);
        }
        if (selectedDashboardResourcePerm.length > 0) {
            resourceDetail.push(dashboardResource);
        }
        if (selectedAuditTrailResourcePerm.length > 0) {
            resourceDetail.push(auditTrailResource);
        }
        if (selectedSettlementTrailResourcePerm.length > 0) {
            resourceDetail.push(settlementResource);
        }
        if (selectedMerchantAdjustmentTrailResourcePerm.length > 0) {
            resourceDetail.push(merchantAdjustmentResource);
        }
        if (selectedMandateResourcePerm.length > 0) {
            resourceDetail.push(mandateResource);
        }

        if (selectedChargebackResourcePerm.length > 0) {
            resourceDetail.push(chargebackResource);
        }

        reqPayload.resourceDetail = resourceDetail;

        actions.updateRoleRequest(reqPayload);
    }

    const isFormReadOnly = actionType === 'view';

    return (
        <form
            className="role-view-edit"
            onSubmit={handleSubmit(handleFormSubmit)}
        >
            <div className="form-section">
                <div className="form-field status-section">
                    <p className="label">Status</p>
                    {isFormReadOnly ? (
                        <>
                            <div className={`status ${data.roleStatus}`}>
                                {data.roleStatus}
                            </div>
                            <div className="lastupdate-status">
                                {data.lastUpdatedByName && (
                                    <>
                                        Last Edit :{' '}
                                        <strong>
                                            {data.lastUpdatedByName},{' '}
                                        </strong>
                                        {moment(
                                            data.lastUpdatedDate,
                                            'DD/MM/YYYY'
                                        )
                                            .calendar()
                                            .indexOf('Today') >= 0
                                            ? 'Today'
                                            : moment(
                                                  data.lastUpdatedDate,
                                                  'DD/MM/YYYY'
                                              )
                                                  .calendar()
                                                  .indexOf('Yesterday') >= 0
                                            ? 'Yesterday'
                                            : data.lastUpdatedDate}
                                    </>
                                )}
                                {!data.lastUpdatedByName && (
                                    <>
                                        Created By :
                                        <strong>
                                            {' '}
                                            {data.roleCreatedByName},{' '}
                                        </strong>
                                        {moment(
                                            data.roleCreationDate,
                                            'DD/MM/YYYY'
                                        )
                                            .calendar()
                                            .indexOf('Today') >= 0
                                            ? 'Today'
                                            : moment(
                                                  data.roleCreationDate,
                                                  'DD/MM/YYYY'
                                              )
                                                  .calendar()
                                                  .indexOf('Yesterday') >= 0
                                            ? 'Yesterday'
                                            : data.roleCreationDate}
                                    </>
                                )}
                            </div>
                        </>
                    ) : (
                        <>
                            <Field
                                name="roleStatus"
                                options={getRoleStatusOptions()}
                                defaultSelected={formData.values.roleStatus.toUpperCase()}
                                valueField="value"
                                labelField="label"
                                component={FormElems.Radio}
                                isDisabled={isFormReadOnly}
                                placeholder="Enter Role Name"
                            />
                            <Field
                                wrapperClass="comment-input"
                                name="remarks"
                                type="textarea"
                                isDisabled={isFormReadOnly}
                                component={FormElems.TextArea}
                                placeholder="Enter Comment "
                            />
                        </>
                    )}
                </div>
            </div>
            <div className="management-section">
                <div className="left-section">
                    <div className="form-section">
                        <p className="label">Access Management</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="access_management"
                                options={accessManagementOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Reports</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="reports"
                                options={reportOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Refunds</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="refunds"
                                options={refundOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Dashboard</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="dashboard"
                                options={dashboardOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Audit Report</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="audit_trail"
                                options={auditTrailOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Merchant Adjustment</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="view_merchant_adjustment"
                                options={merchantAdjustmentOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Chargeback</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="chargeback"
                                options={chargebackOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                </div>
                <div className="right-section">
                    <div className="form-section">
                        <p className="label">Merchant Onboarding</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="merchant_onboarding"
                                options={mobOptions}
                                valueField="value"
                                labelField="label"
                                isDisabled={isFormReadOnly}
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Manage Bin</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="manage_bin"
                                options={manageBinOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Manage Account</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="manage_account"
                                options={manageAccountOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">My Account</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="my_account"
                                options={myAccountOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>

                    <div className="form-section">
                        <p className="label">Payment Links</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="payLink"
                                options={payLinkOptions}
                                valueField="value"
                                labelField="label"
                                isDisabled={isFormReadOnly}
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Settlement</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="view_settlement"
                                options={settlementOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Mandate</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="mandates"
                                options={mandateOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <p className="label">Edit Merchant Onboarding</p>
                        <div
                            className={`form-field ${
                                isFormReadOnly ? 'disabled' : null
                            }`}
                        >
                            <Field
                                name="mandates"
                                options={mobEditOptions}
                                valueField="value"
                                isDisabled={isFormReadOnly}
                                labelField="label"
                                component={FormElems.Checkbox}
                            />
                        </div>
                    </div>
                </div>

                
            </div>
            {isFormReadOnly ? (
                <div className="form-section comment-box">
                    <div className="label">Comment</div>
                    <div className="comment-text" style={{ display: 'block' }}>
                        {data.comment || '-'}
                    </div>
                </div>
            ) : null}
            {updateRole.message ? <Alert>{updateRole.message}</Alert> : null}
            {!isPendingMode ? (
                <div className="form-section action">
                    <FormElems.Button
                        buttonType="secondary"
                        text="CANCEL"
                        handleClick={onCancel}
                        customClass="cancel-btn"
                    />
                    {actionType === 'view' ? (
                        <FormElems.Button
                            buttonType="primary"
                            text="EDIT"
                            handleClick={onEdit}
                            customClass="edit-btn"
                        />
                    ) : (
                        <FormElems.Button buttonType="primary" text="UPDATE" />
                    )}
                </div>
            ) : null}
        </form>
    );
};

const mapStateToProps = ({ auth, roleManagementData, form }) => ({
    auth,
    roleManagementData,
    formData: form.roleViewEdit,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            hideLoader,
            showLoader,
            updateRoleRequest,
            updateRoleReset,
        },
        dispatch
    ),
});

RoleViewEditForm.propTypes = {
    handleSubmit: PropTypes.func,
    closePopup: PropTypes.func,
    actionType: PropTypes.string,
    data: PropTypes.object,
    handleOpenActionPopup: PropTypes.func,
    roleManagementData: PropTypes.object,
    actions: PropTypes.func,
    formData: PropTypes.object,
    fetchData: PropTypes.object,
    resetPage: PropTypes.func,
    isPendingMode: PropTypes.bool,
};

export default compose(
    reduxForm({
        form: 'roleViewEdit',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(RoleViewEditForm);
